
import React from 'react';
import { Alert, AlertTitle, AlertDescription } from '@/components/ui/alert';

interface ErrorAlertProps {
  title: string;
  description: string;
  variant?: 'default' | 'destructive';
}

const ErrorAlert: React.FC<ErrorAlertProps> = ({
  title,
  description,
  variant = 'destructive'
}) => {
  return (
    <Alert variant={variant} className="mb-4">
      <AlertTitle>{title}</AlertTitle>
      <AlertDescription>{description}</AlertDescription>
    </Alert>
  );
};

export default ErrorAlert;
